exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".social-strip[data-v-dd931e50]{gap:6px}", ""]);

// exports
